module.exports = __webpack_public_path__ + "img/icon-url.59d1b74b.svg";